import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import VueIntro from 'vue-introjs';
import VueFormWizard from 'vue-form-wizard';
import VueScrollTo from 'vue-scrollto';
import VueAnalytics from 'vue-analytics';
import { format } from 'date-fns';
import EventHub from 'vue-event-hub';
import i18n from './i18n';
import Lodash from './plugins/Lodash';

import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import { Auth0Plugin } from './auth';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import 'intro.js/introjs.css';

Vue.config.productionTip = false;

Sentry.init({
  dsn: 'https://d230b1340a74495da289d8d523c2ced8@o369448.ingest.sentry.io/4505046365700096',
  integrations: [new VueIntegration({ Vue, attachProps: true, logErrors: process.env.VUE_APP_ENV !== 'production' })],
  release: process.env.VUE_APP_VERSION,
  environment: process.env.VUE_APP_ENV,
});

Vue.use(Lodash);
Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  onRedirectCallback: (appState) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname,
    );
  },
});

Vue.use(EventHub);
Vue.use(VueFormWizard);
Vue.use(VueScrollTo);
Vue.use(VueIntro, {
  waitTimeout: 500,
});
Vue.prototype.$whoAmI = {};

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
  set: [
    { field: 'anonymizeIp', value: true },
  ],
  debug: {
    enabled: process.env.NODE_ENV === 'development',
    sendHitTask: process.env.NODE_ENV === 'production' && process.env.VUE_APP_ENV === 'production',
  },
  checkDuplicatedScript: true,
  router,
});

Vue.filter('onlyDate', (value) => {
  if (value) {
    return format(new Date(value), 'dd/MM/yyyy');
  }
  return '';
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
